<script>
import moment from 'moment';
import NotificationProgramSummary from '@components/notifications/notification-program-summary.vue';
import CardProgramSummary from '@components/cards/card-program-summary.vue';

export default {
  components: {
    NotificationProgramSummary,
    CardProgramSummary,
  },
  props: {
    client: {
      type: Object,
      required: true,
      default: () => {},
    },
    weekData: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      todaysDay: null,
    };
  },
  computed: {
    totalWorkOut() {
      let totalWorkOut = 0;
      this.weekData.days.forEach((day) => {
        if (day.programDay_id) {
          day.workouts.forEach((workout) => {
            if (workout.hasWorkout) {
              totalWorkOut++;
            }
          });
        }
      });
      return totalWorkOut;
    },
    completedWorkOut() {
      let completedWorkOuts = 0;
      this.weekData.days.forEach((day) => {
        if (day.programDay_id) {
          day.workouts.forEach((workout) => {
            if (
              workout.hasWorkout &&
              workout?.clientInput?.startedAt &&
              workout?.clientInput?.workoutProgress?.totalWorkoutElements &&
              workout?.clientInput?.workoutProgress?.completedWorkoutElements &&
              workout.clientInput.workoutProgress.completedWorkoutElements ===
                workout.clientInput.workoutProgress.totalWorkoutElements
            ) {
              completedWorkOuts++;
            }
          });
        }
      });
      return completedWorkOuts;
    },
    pastIncompletedWorkOut() {
      let pastIncompletedWorkOuts = 0;
      this.weekData.days.forEach((day) => {
        if (day.programDay_id) {
          day.workouts.forEach((workout) => {
            if (
              day.dayNumber < this.todaysDay &&
              workout.hasWorkout &&
              (!workout?.clientInput?.workoutProgress?.totalWorkoutElements ||
                !workout.clientInput.workoutProgress.completedWorkoutElements ||
                (workout?.clientInput?.workoutProgress?.totalWorkoutElements &&
                  workout?.clientInput?.workoutProgress
                    ?.completedWorkoutElements &&
                  workout.clientInput.workoutProgress
                    .completedWorkoutElements !==
                    workout.clientInput.workoutProgress.totalWorkoutElements))
            ) {
              pastIncompletedWorkOuts++;
            }
          });
        }
      });
      return pastIncompletedWorkOuts;
    },
    minutesOfExercise() {
      let duration = 0;
      // const coeff = 1000 * 60 * 5;
      this.weekData.days.forEach((day) => {
        if (day.programDay_id) {
          day.workouts.forEach((workout) => {
            if (
              workout.hasWorkout &&
              workout?.clientInput?.startedAt &&
              workout?.clientInput?.workoutProgress?.totalWorkoutElements &&
              workout?.clientInput?.workoutProgress?.completedWorkoutElements &&
              workout.clientInput.workoutProgress.completedWorkoutElements ===
                workout.clientInput.workoutProgress.totalWorkoutElements
            ) {
              duration += workout?.timeToComplete ? workout.timeToComplete : 0;
            }
          });
        }
      });
      return Math.round(duration / (60 * 5)) * 5;
    },
  },
  methods: {
    scrollToCurrentWeek() {
      // scroll to top of current week if client program and more that 4 weeks in the program
      const parent = document.getElementsByClassName('content-wrapper');
      const targetWeek = document.getElementsByClassName('thisWeek');
      if (
        targetWeek &&
        targetWeek.length > 0 &&
        targetWeek[0] &&
        targetWeek[0].getClientRects() &&
        targetWeek[0].getClientRects().length > 0 &&
        targetWeek[0].getClientRects()[0].top &&
        parent &&
        parent.length > 0 &&
        parent[0]
      ) {
        parent[0].scrollTop = targetWeek[0].offsetTop - 148;
      }
    },
  },
  beforeMount() {
    moment.updateLocale('en', {
      week: {
        dow: 1,
      },
    });
    const weekDays = moment.weekdays(true);
    this.todaysDay = weekDays.indexOf(moment().format('dddd')) + 1;
  },
};
</script>

<template>
  <div class="this-week-wrapper h-100">
    <CardProgramSummary :title="'This Week'">
      <template v-slot:icon>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M18.57 12.86L20 11.43 18.57 10 15 13.57 6.43 5 10 1.43 8.57 0 7.14 1.43 5.71 0 3.57 2.14 2.14.71.71 2.14l1.43 1.43L0 5.71l1.43 1.43L0 8.57 1.43 10 5 6.43 13.57 15 10 18.57 11.43 20l1.43-1.43L14.29 20l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L20 14.29l-1.43-1.43z"/></svg>
      </template>
      <h6 class="title mb-3">Workouts Completed</h6>
      <template v-if="totalWorkOut">
        <div class="workout-progress row mb-4">
          <template v-for="index in totalWorkOut">
            <div class="col col-progress" :key="`workout-progress-${index}`">
              <div class="progress">
                <div
                  class="progress-bar progress-bar-blue"
                  :style="{ width: index <= completedWorkOut ? '100%' : '0%' }"
                ></div>
              </div>
            </div>
          </template>
        </div>
        <div class="divider-horizontal">&nbsp;</div>
        <div class="subdata mb-4">
          <span class="subtitle">Minutes of Exercise</span>
          <span class="figure">{{ minutesOfExercise }}</span>
        </div>
        <div class="divider-horizontal">&nbsp;</div>
        <NotificationProgramSummary
          type="warning"
          :icon="true"
          heading="NOTIFICATIONS"
          v-if="pastIncompletedWorkOut"
        >
          <template v-slot:icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="27.393" height="24" viewBox="0 0 27.393 24" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path data-name="Subtraction 1" d="M26.348 24H1.045a1.043 1.043 0 01-.9-1.566L12.793.522a1.044 1.044 0 011.808 0l12.651 21.913a1.044 1.044 0 01-.9 1.566zM12.4 17.8v2.03h2.045V17.8H12.4zm-.1-8.269l.57 7.246h1.11l.57-7.246H12.3z"/></svg>
          </template>
          <h5>Missed Workout</h5>
          <div class="content">Send a message of encouragement.</div>
          <router-link
            :to="{
              name: 'clientMessages',
              params: { id: client._id, client: client },
            }"
            >Open Messages</router-link
          >
        </NotificationProgramSummary>
      </template>
      <template v-else>
        <div class="workout-progress row mb-4">
          <div class="col col-progress">
            <div class="progress">
              <div class="progress-bar progress-bar-blue"></div>
            </div>
          </div>
          <div class="col col-progress">
            <div class="progress">
              <div class="progress-bar progress-bar-blue"></div>
            </div>
          </div>
          <div class="col col-progress">
            <div class="progress">
              <div class="progress-bar progress-bar-blue"></div>
            </div>
          </div>
          <div class="col col-progress">
            <div class="progress">
              <div class="progress-bar progress-bar-blue"></div>
            </div>
          </div>
        </div>
        <div class="divider-horizontal mb-4">&nbsp;</div>
        <NotificationProgramSummary type="blue" :icon="true">
          <template v-slot:icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path data-name="Subtraction 2" d="M12 24A12 12 0 013.515 3.515a12 12 0 1116.97 16.97A11.922 11.922 0 0112 24zm-.886-8.946V17h1.96v-1.946zM12.15 8.5a1.509 1.509 0 01.952.266.882.882 0 01.336.728 1.6 1.6 0 01-.182.742 3.785 3.785 0 01-.616.84 4.972 4.972 0 00-.84 1.224 3.1 3.1 0 00-.238 1.219v.56h1.064l.056-.392a2.675 2.675 0 01.322-.9 4.662 4.662 0 01.91-1.05 4.418 4.418 0 001.008-1.218 2.563 2.563 0 00.294-1.2 2.016 2.016 0 00-.378-1.219 2.424 2.424 0 00-1.038-.816 3.781 3.781 0 00-1.541-.293 5.181 5.181 0 00-1.778.321 4.483 4.483 0 00-1.456.854l.591 1.344A3.807 3.807 0 0112.15 8.5z"/></svg>
          </template>
          <h5>Notifications</h5>
          <div class="content">Notifications are updated by you calendar.</div>
          <a href="#" @click="scrollToCurrentWeek">Jump to Current Week</a>
        </NotificationProgramSummary>
      </template>
    </CardProgramSummary>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
.subdata {
  align-items: center;
  display: flex;
  justify-content: space-between;
  justify-self: center;
  margin-bottom: 1rem;
  margin-top: 1rem;
  width: 100%;
  .subtitle {
    color: $color-dark-gray-five;
    font-size: 10px;
    font-weight: 900;
    letter-spacing: 0.702381px;
    line-height: 19px;
    text-transform: uppercase;
  }
  .figure {
    color: $color-black-one;
    font-weight: normal;
    letter-spacing: -0.0666664px;
    mix-blend-mode: normal;
    opacity: 0.6;
    text-align: right;
  }
}
.divider-horizontal {
  align-self: center;
  border-top: 1px solid $color-gray;
  height: 0.5rem;
  margin-left: auto;
  margin-right: auto;
  opacity: 0.5;
  opacity: 0.2;
  width: 100%;
}
h6.title {
  color: $color-dark-gray-two;
  font-size: 10px;
  font-weight: 900;
  line-height: 14px;
  margin: 10px 0;
  text-transform: uppercase;
}
.progress-bar-blue {
  background-color: $color-primary;
}
</style>

<style lang="scss">
@import '@design';
.this-week-wrapper {
  .col-progress {
    padding-left: 2px;
    padding-right: 2px;
    .progress {
      border-radius: 0;
    }
    &:first-child {
      padding-left: 15px;
      .progress {
        border-bottom-left-radius: 1rem;
        border-top-left-radius: 1rem;
      }
    }
    &:last-child {
      padding-right: 15px;
      .progress {
        border-bottom-right-radius: 1rem;
        border-top-right-radius: 1rem;
      }
    }
  }
}
</style>
